module.exports = __webpack_public_path__ + "static/logo-horizontal-666d4479cfe1ed30ef801e354f744841.png";